// extracted by mini-css-extract-plugin
module.exports = {"youtube-wrap":"_____2_Mobile_youtube-wrap__TPi2i","slider":"_____2_Mobile_slider__Kpndp","item":"_____2_Mobile_item__vkOap","dots_custom":"_____2_Mobile_dots_custom__FIZ0y"};